import { useEffect, useState } from 'react';

import { getWebAnalyticsModule } from '@storefront/utils/webAnalytics';

import {
  pageVisualizationEvent,
  PageVisualizationEventProps,
} from '../pageVisualizationEvent';

const usePageVisualizationEvent = (props: PageVisualizationEventProps) => {
  const [screenLoadEventSent, setScreenLoadEventSent] = useState(false);
  const webAnalyticsStarted = getWebAnalyticsModule()?.isInited;

  useEffect(() => {
    if (screenLoadEventSent) return;
    async function handleEvent() {
      await pageVisualizationEvent(props);
      setScreenLoadEventSent(true);
    }
    if (webAnalyticsStarted && !screenLoadEventSent) {
      handleEvent();
    }
  }, [screenLoadEventSent]);
};

export default usePageVisualizationEvent;
